import React from 'react';

const Footer = () => {
    return (
        <div className='bg-dark'>
            <h3 className='text-light text-center fixed p-3'>© 2021 ghosh  Hospital</h3>
        </div>
    );
};

export default Footer;